const ErrorUtil = {
    getMessage(error) {
        try {
            const jsonError = JSON.parse(error.message);
            if (jsonError.detail) {
                return jsonError.detail;
            }
            return Object.keys(jsonError)
                .map(key => `${key}: ${jsonError[key].join(", ")}`)
                .join("\n");
        } catch (e) {
            const cleanErrorMessage = error?.message
                ?.replace(/['"]+/g, "")
                .replace(/[[\]']+/g, "");
            return error.message ? cleanErrorMessage : error;
        }
    },
};

export default ErrorUtil;
